import axios from "axios"
import { GrupoImpuestoReadingDtoProps } from "./DTOs/GrupoImpuestoReadingDto"
import { getGrupoImpuestoAdapter } from "./GrupoImpuesto.adapter"

export async function getGrupoImpuesto(): Promise<
  Array<GrupoImpuestoReadingDtoProps>
> {
  const { data } = await axios.get("/GrupoImpuesto")

  return data?.map((grupoImpuesto: GrupoImpuestoReadingDtoProps) =>
    getGrupoImpuestoAdapter(grupoImpuesto)
  )
}
